import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

/** Last-resort UI boundary — users never see a white screen. */
export class ErrorBoundary extends Component<PropsWithChildren, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Central logger is injected app-wide; boundary logs defensively on its own.
    console.error('Unhandled UI error', { message: error.message, componentStack: info.componentStack });
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div role="alert" style={{ padding: 24, textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p>Please refresh the app. If the problem persists, contact support.</p>
          <button onClick={() => window.location.reload()}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}
